import type { SVGProps } from "react";

export const Bill = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="35"
    viewBox="0 0 53 35"
    width="53"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Bill</title>
    <path
      d="M7.94446 9.58851V0.992188L16.3421 7.49068C19.2503 9.77072 19.8019 13.0895 19.7338 13.0065C17.8404 10.6541 15.3118 9.62186 13.5711 9.5942L7.94446 9.58851Z"
      fill="#FF9C6C"
    />
    <path
      d="M30.5708 11.4436H24.2873V34.1798H30.5708V11.4436Z"
      fill="#FF5A0A"
    />
    <path
      d="M41.5871 0.709961H35.3036V34.1801H41.5871V0.709961Z"
      fill="#FF5A0A"
    />
    <path
      d="M52.5987 0.709961H46.3152V34.1801H52.5987V0.709961Z"
      fill="#FF5A0A"
    />
    <path
      d="M13.4448 26.3255C13.4448 27.3382 12.5663 28.1695 11.5732 28.1695H6.20995V17.3477H11.5732C12.5725 17.3477 13.4448 18.1693 13.4448 19.1917V26.3255ZM6.25178 11.4511V0.723633H0V34.1767H13.083C16.7636 34.1767 19.7454 31.0458 19.7454 27.1812V18.4466C19.7454 14.582 16.7636 11.4511 13.083 11.4511H6.25178Z"
      fill="#FF5A0A"
    />
    <circle cx="27.3911" cy="4.10487" fill="#FF5A0A" r="4.10487" />
  </svg>
);

export default Bill;
